const $reveal = new Foundation.Reveal($("#GeoConsultantsBanner"));
$(".close-button").on("click", (e) => {
  $reveal.close();
});
  //public api key -- fine to be visible
  let mapbox_api =
    "pk.eyJ1IjoiYWt1ZGVuanMiLCJhIjoiY2s4ZXJuNWp1MDBpMzNscWszMXU4Y212MCJ9.ZGKzqv_Cj8NF-YrmJ_ymRQ";
  //==========options for geolocation permission===============
  var options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  //97526
  var mapState = {
    lat: 40.737,
    long: -97.923,
  };

  //change the mapState to the newly updated state
  var updateState = (...args) => {
    var newState = {
      lat: args[0],
      long: args[1],
    };
    return Object.assign(mapState, newState);
  };

  function success(pos) {
    var crd = pos.coords;
    updateState(crd.latitude, crd.longitude);
    console.log(mapState);
    getLocationInfo(mapState.long, mapState.lat);
  }

  function error(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
    $reveal.close();
  }
  //==========end options and functions for geolocation permission=========

  function getLocationInfo(long, lat) {
    let url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${long},${lat}.json?access_token=${mapbox_api}`;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        let state = '';
        console.log(data.features.length)
        console.log(data.features);
        if (data.features.length === 6) {
          state = data.features[4].text;
          console.log(state);
        } else if (data.features.length === 4) {
          state = data.features[2].text;
          console.log(state);
        } else {
          state = "Oregon";
        }
        
        //$(`#form-input-state option[text=${state}]`).attr('selected','selected');
        $("#form-input-state option").filter(function() {
          //may want to use $.trim in here
          return $(this).text() == state;
        }).prop('selected', true);
    
        getConsultants(state);
      });
  }

  function getConsultants(state) {
    $('.default.consultant-detail').hide();
    $('.geo-consultant-results').html('');
    $.ajax({
        url: '/get-consultant-by-state',
        dataType: 'json',
        data: {
            region: state,
        },
    })
        .done(function(data) {
          let results = data.payload;
          if (results == "No results found") {
            $reveal.close();
          } else {
            results.forEach(element => {
              //console.log(element);
              $('.geo-consultant-results').append(
                '<div class="consultant-detail border-b-4 border-green-500 mb-5">' +
                element.title + '<br />' +
                  (element.streetAddress
                    ? element.streetAddress + '<br />'
                    : '' ) +
                  (element.cityStateZip
                    ? element.cityStateZip + ''
                    : '') +
                  (element.phone
                    ? '<br />Tel: <a href="tel:' + element.phone + '">' + element.phone + '</a>'
                    : '') +
                  (element.fax
                    ? '<br />Fax: <a href="tel:' + element.fax + '">' + element.fax + '</a>'
                    : '') +
                  (element.email
                    ? '<br />Contact: <a href="mailto:' + element.email + '">' + element.email  + '</a>'
                    : '') +
  
                  (element.website && !checkString(element.website,'playcraft')
                    ? '<br />Website: <a href="' + element.website + '" target="_blank">' + element.website + '</a>'
                    : '') +
                '<br /><br /></div>'
            );
            });
                showBannerContents();
          }
          
        })
        .fail(function(data, msg) {
            $reveal.close();
            console.log(msg);
        });
}

function showBannerContents() {
  $reveal.open();
}

function checkString(str,sub) {
  return (str.indexOf(sub) !== -1);
}

navigator.geolocation.getCurrentPosition(success, error, options);